
export default function BatchInput({inputs, onChange}) {
    return (
        <div className={"col"}>
            <label htmlFor={`batchName`} className={"form-label"}>Batch name:</label>
            <input className={"form-control"} type={"text"} name={`batchName`} id={`batchName`} value={inputs.batchName} onChange={onChange} required={true} />
        </div>
    );
}